import { render, staticRenderFns } from "./inspections-and-ca-warnings-list.component.vue?vue&type=template&id=097f2c93"
import script from "./inspections-and-ca-warnings-list.component.ts?vue&type=script&lang=ts&external"
export * from "./inspections-and-ca-warnings-list.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097f2c93')) {
      api.createRecord('097f2c93', component.options)
    } else {
      api.reload('097f2c93', component.options)
    }
    module.hot.accept("./inspections-and-ca-warnings-list.component.vue?vue&type=template&id=097f2c93", function () {
      api.rerender('097f2c93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/warnings-list/inspections-and-ca-warnings-list.component.vue"
export default component.exports